const THEME = {
	COLORS: {
		WHITE: '#FFFFFF',
		BLACK: '#000000',
		ANTAGONISTA_COLOR: '#00A7C4',
		LIGHT_GRAFFITI: '#8F8F8F',
		SUCCESS: '#21C25E',
		ERROR: '#ff3333',
		ORANGE_ERROR: '#FFA500',
		GREY: '#D1D1D1',
		MID_GREY: '#616161',
		DARK_GREY: '#444444',

		//outside theme colors
		row_color: '#E6E6E6',
		summary_background: '#FAFAFA',
		download_background: '#F6F6F6'
	}
}

export { THEME }
